<div class="m-story-contribution" [hidden]="!loadStatus.isLoaded" *ngIf="storyDetail?.contributions?.length > 0">
  <div style="font-weight: 900" class="m-story-contribution__title m-story-title">Named in Story</div>
  <div class="m-story-contribution__conts">
    <app-pb-contributor-item *ngFor="let contribution of storyDetail.contributions; trackBy: trackByFunc"
      [contribution]="contribution">
    </app-pb-contributor-item>
  </div>
</div>
<skeleton-pb-contributor-list [hidden]="!loadStatus.isLoading"></skeleton-pb-contributor-list>